import { useEffect } from 'react';

/**
 * MUI 9 removed Dialog `disableEscapeKeyDown`. Esc would close every Dialog
 * unless onClose ignores `reason === 'escapeKeyDown'`.
 *
 * Capture-phase listener: if a MUI Dialog is open, swallow Escape so no Dialog
 * (View, Edit, Add, confirms) closes. Select/Autocomplete menus inside a Dialog
 * also will not close on Esc (click away still works).
 *
 * See docs/VIEW_EDIT_MODAL_PATTERN.md and Mantis #18.
 */
export default function DialogEscapeGuard() {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      if (!document.querySelector('.MuiDialog-root')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    document.addEventListener('keydown', onKeyDown, true);
    return () => document.removeEventListener('keydown', onKeyDown, true);
  }, []);

  return null;
}
